(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestseller-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
  const toBool = (value) => String(value) === 'true';

  function mountBestsellerSection(root) {
    if (!root || root.dataset.pbsReady === 'true') return;
    root.dataset.pbsReady = 'true';

    const data = root.querySelector('[data-pbs-config]')?.dataset || {};
    const config = {
      sizeOptionName: data.sizeOptionName || 'Size',
      sizeDisplayMode: data.sizeDisplayMode || 'full',
      sizeDefaultSelection: data.sizeDefaultSelection || 'none',
      hideUnavailableSizes: toBool(data.hideUnavailableSizes),
      selectSizeText: data.selectSizeText || 'Select size',
      atcText: data.atcText || 'Add to cart',
      loadingText: data.loadingText || 'Adding…',
      addedText: data.addedText || 'Added',
      soldOutText: data.soldOutText || 'Sold out',
      successMessage: data.successMessage || 'Product added to cart.',
      showCompare: toBool(data.showCompare),
      showDiscount: toBool(data.showDiscount),
      discountFormat: data.discountFormat || 'percentage',
      reviewsEnabled: toBool(data.reviewsEnabled),
      reviewsHideWhenEmpty: toBool(data.reviewsHideWhenEmpty),
      reviewShowRating: toBool(data.reviewShowRating),
      reviewShowCount: toBool(data.reviewShowCount),
      reviewSeparator: data.reviewSeparator || 'space',
      reviewCountFormat: data.reviewCountFormat || 'label',
      reviewLabel: data.reviewLabel || 'reviews',
      mobileGallery: toBool(data.mobileGallery),
      galleryIndicator: data.galleryIndicator || 'counter',
      showSecondImage: toBool(data.showSecondImage),
      currency: data.currency || 'INR'
    };

    const productCache = new Map();


    function formatMoney(cents) {
      const value = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
          style: 'currency',
          currency: config.currency || 'INR',
          maximumFractionDigits: Number.isInteger(value) ? 0 : 2
        }).format(value);
      } catch (e) {
        return `₹${value.toFixed(0)}`;
      }
    }

    function parseReviewMap(root) {
      const map = new Map();
      const raw = root.querySelector('[data-pbs-review-pairs]')?.textContent?.trim() || '';
      raw.split(';').forEach((pair) => {
        if (!pair) return;
        const [id, ratingRaw] = pair.split(':');
        const rating = Number(ratingRaw);
        if (!id || !Number.isFinite(rating)) return;
        const existing = map.get(String(id)) || { sum: 0, count: 0 };
        existing.sum += rating;
        existing.count += 1;
        map.set(String(id), existing);
      });
      return map;
    }

    function reviewText(avg, count) {
      const chunks = [];
      if (config.reviewShowRating) chunks.push(avg.toFixed(1));
      if (config.reviewShowCount) {
        let countText = '';
        if (config.reviewCountFormat === 'brackets') countText = `(${count})`;
        else if (config.reviewCountFormat === 'number_only') countText = String(count);
        else countText = `${count} ${config.reviewLabel}`;

        if (chunks.length) {
          if (config.reviewSeparator === 'pipe') chunks.push('|');
          else if (config.reviewSeparator === 'dot') chunks.push('·');
        }
        chunks.push(countText);
      }
      return chunks.join(' ');
    }

    function updateReview(card, productId, reviewMap) {
      if (!config.reviewsEnabled) return;
      const wrap = card.querySelector('[data-pbs-rating-wrap]');
      if (!wrap) return;
      const stats = reviewMap.get(String(productId)) || { sum: 0, count: 0 };
      const avg = stats.count ? Math.round((stats.sum / stats.count) * 10) / 10 : 0;
      wrap.hidden = Boolean(config.reviewsHideWhenEmpty && stats.count === 0);
      wrap.setAttribute('aria-label', `${avg.toFixed(1)} out of 5 from ${stats.count} reviews`);
      const fill = wrap.querySelector('[data-pbs-rating-fill]');
      if (fill) fill.style.setProperty('--rating-fill', `${Math.max(0, Math.min(100, avg * 20))}%`);
      const text = wrap.querySelector('[data-pbs-rating-text]');
      if (text) text.textContent = reviewText(avg, stats.count);
    }

    function productUrl(handle, preferredUrl) {
      if (preferredUrl) return preferredUrl;
      const root = window.Shopify?.routes?.root || '/';
      return `${root}products/${handle}`;
    }

    async function fetchProduct(handle) {
      if (productCache.has(handle)) return productCache.get(handle);
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Unable to load this color.');
      const product = await response.json();
      productCache.set(handle, product);
      return product;
    }

    function productImages(product) {
      const images = Array.isArray(product?.images) ? product.images : [];
      return images.map((image) => {
        if (typeof image === 'string') return { src: image, alt: product.title || '' };
        return {
          src: image?.src || image?.url || '',
          alt: image?.alt || product.title || ''
        };
      }).filter((image) => image.src);
    }

    function setImageElement(img, source, alt) {
      if (!img || !source) return;
      img.src = source;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.alt = alt || '';
    }

    function renderGalleryIndicator(card) {
      const indicator = card.querySelector('[data-pbs-gallery-indicator]');
      if (!indicator) return;
      const images = card._pbsGallery || [];
      const index = card._pbsGalleryIndex || 0;
      indicator.hidden = images.length <= 1 || config.galleryIndicator === 'none';
      if (indicator.hidden) return;

      if (config.galleryIndicator === 'dots') {
        indicator.classList.add('is-dots');
        indicator.innerHTML = images.map((_, i) => `<span class="pbs-gallery-mini-dot${i === index ? ' is-active' : ''}"></span>`).join('');
      } else {
        indicator.classList.remove('is-dots');
        indicator.textContent = `${index + 1} / ${images.length}`;
      }
    }

    function renderGallery(card) {
      const images = card._pbsGallery || [];
      const count = images.length;
      const prev = card.querySelector('[data-pbs-gallery-prev]');
      const next = card.querySelector('[data-pbs-gallery-next]');
      if (prev) prev.hidden = count <= 1;
      if (next) next.hidden = count <= 1;

      if (!count) {
        renderGalleryIndicator(card);
        return;
      }

      card._pbsGalleryIndex = Math.max(0, Math.min(card._pbsGalleryIndex || 0, count - 1));
      const media = card.querySelector('.pbs-media');
      let main = card.querySelector('.pbs-image');
      if (!main && media) {
        main = document.createElement('img');
        main.className = 'pbs-image';
        main.loading = 'lazy';
        media.querySelector('.pbs-placeholder')?.remove();
        media.prepend(main);
      }

      const current = images[card._pbsGalleryIndex];
      setImageElement(main, current.src, current.alt);

      let secondary = card.querySelector('.pbs-image--secondary');
      if (config.showSecondImage && count > 1) {
        if (!secondary && media) {
          secondary = document.createElement('img');
          secondary.className = 'pbs-image--secondary';
          secondary.loading = 'lazy';
          media.appendChild(secondary);
        }
        if (secondary) {
          const secondaryImage = images[(card._pbsGalleryIndex + 1) % count];
          setImageElement(secondary, secondaryImage.src, secondaryImage.alt);
        }
      }

      renderGalleryIndicator(card);
    }

    function setGallery(card, images) {
      card._pbsGallery = images || [];
      card._pbsGalleryIndex = 0;
      renderGallery(card);
    }

    function moveGallery(card, direction) {
      const images = card._pbsGallery || [];
      if (images.length <= 1) return;
      const nextIndex = ((card._pbsGalleryIndex || 0) + direction + images.length) % images.length;
      card._pbsGalleryIndex = nextIndex;
      renderGallery(card);
    }

    function optionObjects(product) {
      const rawOptions = Array.isArray(product?.options) ? product.options : [];
      return rawOptions.map((option, index) => {
        if (typeof option === 'string') {
          const values = [];
          (product.variants || []).forEach((variant) => {
            const value = variant.options?.[index] ?? variant[`option${index + 1}`];
            if (value != null && !values.includes(value)) values.push(value);
          });
          return { name: option, position: index + 1, values };
        }
        return {
          name: option.name || option.title || `Option ${index + 1}`,
          position: Number(option.position || index + 1),
          values: Array.isArray(option.values) ? option.values : []
        };
      });
    }

    function variantOptionValue(variant, optionIndex, position) {
      return variant?.options?.[optionIndex] ?? variant?.[`option${position}`] ?? null;
    }

    function sizeLabel(value) {
      const text = String(value ?? '').trim();
      if (config.sizeDisplayMode === 'letter_only' && text.includes('/')) return text.split('/')[0].trim();
      if (config.sizeDisplayMode === 'number_only' && text.includes('/')) return text.split('/').pop().trim();
      return text;
    }

    function firstAvailableVariant(product) {
      return (product?.variants || []).find((variant) => variant.available) || product?.variants?.[0] || null;
    }

    function updatePrice(card, variant) {
      if (!variant) return;
      const current = card.querySelector('[data-pbs-price-current]');
      const compare = card.querySelector('[data-pbs-price-compare]');
      const discount = card.querySelector('[data-pbs-discount]');
      const price = Number(variant.price || 0);
      const comparePrice = Number(variant.compare_at_price || 0);
      const onSale = comparePrice > price && price > 0;

      if (current) current.textContent = formatMoney(price);
      if (compare) {
        compare.hidden = !onSale;
        if (onSale) compare.textContent = formatMoney(comparePrice);
      }
      if (discount) {
        discount.hidden = !onSale;
        if (onSale) {
          const saving = comparePrice - price;
          const percent = Math.round((saving * 100) / comparePrice);
          if (config.discountFormat === 'save') discount.textContent = `Save ${formatMoney(saving)}`;
          else if (config.discountFormat === 'both') discount.textContent = `${percent}% OFF · Save ${formatMoney(saving)}`;
          else discount.textContent = `${percent}% OFF`;
        }
      }
    }

    function syncWishlistData(card, product, variant, url, images) {
      const button = card.querySelector('[data-pbs-wishlist]');
      if (!button || !product) return;
      button.dataset.productHandle = product.handle || '';
      button.dataset.productId = product.id || '';
      button.dataset.productTitle = product.title || '';
      button.dataset.productUrl = url || '';
      button.dataset.productImage = images?.[0]?.src || product.featured_image || '';
      button.dataset.productPrice = variant ? formatMoney(variant.price) : '';
      button.dataset.productVariantId = variant?.id || '';
      button.setAttribute('aria-label', `Add ${product.title || 'product'} to wishlist`);
      button.classList.remove('is-active');
      button.setAttribute('aria-pressed', 'false');
      document.dispatchEvent(new CustomEvent('wishlist:product-changed', {
        bubbles: true,
        detail: { button, product }
      }));
    }

    function configureActions(card, product, selectedVariant, hasSizeOption, productPageUrl) {
      const form = card.querySelector('.pbs-atc-form');
      const viewLink = card.querySelector('[data-pbs-view-product]');
      const input = form?.querySelector('[data-pbs-variant-input]');
      const button = form?.querySelector('[data-pbs-atc-button]');
      const label = form?.querySelector('[data-pbs-atc-label]');
      const availableVariant = selectedVariant || firstAvailableVariant(product);
      if (viewLink) viewLink.href = productPageUrl;
      if (form) form.hidden = false;
      if (!button || !input) return;

      const isAvailable = Boolean(product?.available && availableVariant?.available);
      const requiresSize = hasSizeOption && config.sizeDefaultSelection === 'none' && !selectedVariant;
      input.value = selectedVariant?.id || (!requiresSize ? availableVariant?.id || '' : '');
      button.hidden = false;
      button.disabled = !isAvailable || requiresSize;
      button.toggleAttribute('data-size-selection-required', requiresSize);

      if (label) {
        if (!product?.available || !availableVariant) label.textContent = config.soldOutText;
        else if (requiresSize) label.textContent = config.selectSizeText;
        else label.textContent = button.dataset.pbsAtcText || config.atcText;
      }
    }

    function renderSizes(card, product) {
      const wrap = card.querySelector('[data-pbs-size-wrap]');
      const list = card.querySelector('[data-pbs-size-list]');
      const options = optionObjects(product);
      const target = String(config.sizeOptionName || 'Size').toLowerCase();
      const sizeOption = options.find((option) => String(option.name || '').toLowerCase() === target);
      if (!wrap || !list) return { sizeOption: null, selectedVariant: null };

      if (!sizeOption) {
        wrap.hidden = true;
        list.innerHTML = '';
        return { sizeOption: null, selectedVariant: null };
      }

      wrap.hidden = false;
      const optionIndex = Math.max(0, Number(sizeOption.position || 1) - 1);
      const buttons = [];
      let selectedVariant = null;

      (sizeOption.values || []).forEach((value) => {
        const matches = (product.variants || []).filter((variant) => String(variantOptionValue(variant, optionIndex, sizeOption.position)) === String(value));
        const available = matches.find((variant) => variant.available) || null;
        const fallback = matches[0] || null;
        if (config.hideUnavailableSizes && !available) return;

        if (!selectedVariant && config.sizeDefaultSelection === 'first_available' && available) selectedVariant = available;
        const selected = Boolean(selectedVariant && available && selectedVariant.id === available.id);
        buttons.push(`<button type="button" class="pbs-size-option${selected ? ' is-selected' : ''}" data-pbs-size-option data-variant-id="${available?.id || fallback?.id || ''}" data-size-value="${String(value).replace(/"/g, '&quot;')}" aria-pressed="${selected ? 'true' : 'false'}" ${available ? '' : 'disabled aria-disabled="true"'}>${sizeLabel(value)}</button>`);
      });

      list.innerHTML = buttons.join('');
      return { sizeOption, selectedVariant };
    }

    function applyProduct(card, product, swatch, reviewMap) {
      const url = productUrl(product.handle, swatch?.dataset.productUrl);
      const images = productImages(product);
      const variant = firstAvailableVariant(product);

      card.dataset.currentHandle = product.handle || '';
      card.dataset.currentProductId = product.id || '';
      card._pbsProduct = product;

      card.querySelectorAll('[data-pbs-product-link]').forEach((link) => {
        link.href = url;
        link.setAttribute('aria-label', product.title || 'View product');
      });
      const titleLink = card.querySelector('[data-pbs-title-link]');
      if (titleLink) {
        titleLink.href = url;
        titleLink.textContent = product.title || '';
      }

      const colorName = swatch?.dataset.colorName || product.title || '';
      const colorNameNode = card.querySelector('[data-pbs-color-current-name]');
      if (colorNameNode) colorNameNode.textContent = colorName;

      card.querySelectorAll('[data-pbs-color-switch]').forEach((button) => {
        const active = button === swatch || button.dataset.productHandle === product.handle;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });

      setGallery(card, images);
      updateReview(card, product.id, reviewMap);
      updatePrice(card, variant);

      const { sizeOption, selectedVariant } = renderSizes(card, product);
      configureActions(card, product, selectedVariant, Boolean(sizeOption), url);
      syncWishlistData(card, product, selectedVariant || variant, url, images);

      card.classList.remove('pbs-product-switch-flash');
      void card.offsetWidth;
      card.classList.add('pbs-product-switch-flash');
      setTimeout(() => card.classList.remove('pbs-product-switch-flash'), 420);
    }

      const liveRegion = root.querySelector('[data-pbs-live-region]');
      const reviewMap = parseReviewMap(root);

      root.querySelectorAll('[data-pbs-card]').forEach((card) => {
        const galleryData = card.querySelector('[data-pbs-gallery-data]');
        try {
          card._pbsGallery = JSON.parse(galleryData?.textContent || '[]');
        } catch (e) {
          card._pbsGallery = [];
        }
        card._pbsGalleryIndex = 0;
        renderGalleryIndicator(card);

        const media = card.querySelector('.pbs-media');
        if (media && config.mobileGallery) {
          let touchStartX = null;
          media.addEventListener('touchstart', (event) => {
            touchStartX = event.touches?.[0]?.clientX ?? null;
          }, { passive: true });
          media.addEventListener('touchend', (event) => {
            if (touchStartX == null) return;
            const endX = event.changedTouches?.[0]?.clientX ?? touchStartX;
            const delta = endX - touchStartX;
            touchStartX = null;
            if (Math.abs(delta) > 45) {
              event.preventDefault?.();
              moveGallery(card, delta < 0 ? 1 : -1);
            }
          }, { passive: false });
        }
      });

      root.addEventListener('click', async (event) => {
        const prev = event.target.closest('[data-pbs-gallery-prev]');
        if (prev && root.contains(prev)) {
          event.preventDefault();
          moveGallery(prev.closest('[data-pbs-card]'), -1);
          return;
        }

        const next = event.target.closest('[data-pbs-gallery-next]');
        if (next && root.contains(next)) {
          event.preventDefault();
          moveGallery(next.closest('[data-pbs-card]'), 1);
          return;
        }

        const sizeButton = event.target.closest('[data-pbs-size-option]');
        if (sizeButton && root.contains(sizeButton)) {
          if (sizeButton.disabled) return;
          const card = sizeButton.closest('[data-pbs-card]');
          card.querySelectorAll('[data-pbs-size-option]').forEach((button) => {
            const selected = button === sizeButton;
            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });

          const form = card.querySelector('.pbs-atc-form');
          const input = form?.querySelector('[data-pbs-variant-input]');
          const atcButton = form?.querySelector('[data-pbs-atc-button]');
          const label = form?.querySelector('[data-pbs-atc-label]');
          const variantId = String(sizeButton.dataset.variantId || '');
          if (input) input.value = variantId;
          if (atcButton && variantId) {
            atcButton.disabled = false;
            atcButton.removeAttribute('data-size-selection-required');
          }
          if (label && atcButton?.dataset.pbsAtcText) label.textContent = atcButton.dataset.pbsAtcText;

          if (card._pbsProduct) {
            const variant = (card._pbsProduct.variants || []).find((item) => String(item.id) === variantId);
            if (variant) {
              updatePrice(card, variant);
              const url = productUrl(card._pbsProduct.handle, card.querySelector('[data-pbs-view-product]')?.href);
              syncWishlistData(card, card._pbsProduct, variant, url, card._pbsGallery || []);
            }
          }
          return;
        }

        const swatch = event.target.closest('[data-pbs-color-switch]');
        if (swatch && root.contains(swatch)) {
          event.preventDefault();
          const card = swatch.closest('[data-pbs-card]');
          const handle = swatch.dataset.productHandle;
          if (!card || !handle || card.dataset.currentHandle === handle) return;

          swatch.setAttribute('aria-busy', 'true');
          card.classList.add('is-color-loading');
          try {
            const product = await fetchProduct(handle);
            applyProduct(card, product, swatch, reviewMap);
            if (liveRegion) liveRegion.textContent = `${product.title} selected.`;
          } catch (error) {
            if (liveRegion) liveRegion.textContent = error.message || 'Unable to load this color.';
          } finally {
            swatch.removeAttribute('aria-busy');
            card.classList.remove('is-color-loading');
          }
        }
      });

      root.querySelectorAll('.pbs-atc-form').forEach((form) => {
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = form.querySelector('[data-pbs-atc-button]');
          const label = form.querySelector('[data-pbs-atc-label]');
          if (!button || button.disabled) return;

          const originalText = label ? label.textContent : '';
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          if (label) label.textContent = config.loadingText;

          try {
            const response = await fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(form)
            });
            if (!response.ok) {
              const errorData = await response.json().catch(() => ({}));
              throw new Error(errorData.description || 'Unable to add this item.');
            }

            if (label) label.textContent = config.addedText;
            if (liveRegion) liveRegion.textContent = config.successMessage;
            document.dispatchEvent(new CustomEvent('pbs:cart-added', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            setTimeout(() => {
              if (label) label.textContent = originalText;
            }, 1400);
          } catch (error) {
            if (label) label.textContent = originalText;
            if (liveRegion) liveRegion.textContent = error.message || 'Unable to add this item.';
          } finally {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        });
      });

      const grid = root.querySelector('[data-pbs-grid]');
      const dotsWrap = root.querySelector('[data-pbs-dots]');
      if (grid && dotsWrap && window.matchMedia('(max-width: 749px)').matches) {
        const items = [...grid.querySelectorAll('.pbs-item')];
        if (items.length > 1) {
          items.forEach((item, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = `pbs-slider-dot${index === 0 ? ' is-active' : ''}`;
            dot.setAttribute('aria-label', `Go to product ${index + 1}`);
            dot.addEventListener('click', () => item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
            dotsWrap.appendChild(dot);
          });

          const dots = [...dotsWrap.children];
          let rafId = null;
          grid.addEventListener('scroll', () => {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
              const left = grid.scrollLeft;
              let closestIndex = 0;
              let closestDistance = Infinity;
              items.forEach((item, index) => {
                const distance = Math.abs(item.offsetLeft - left - grid.offsetLeft);
                if (distance < closestDistance) {
                  closestDistance = distance;
                  closestIndex = index;
                }
              });
              dots.forEach((dot, index) => dot.classList.toggle('is-active', index === closestIndex));
            });
          }, { passive: true });
        }
      }
  }

  document.querySelectorAll('[data-pbs-section]').forEach(mountBestsellerSection);

  document.addEventListener('shopify:section:load', (event) => {
    const direct = event.target?.matches?.('[data-pbs-section]') ? event.target : null;
    const root = direct || event.target?.querySelector?.('[data-pbs-section]');
    if (root) mountBestsellerSection(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["combo-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const SELECTOR = '[data-cb-root]';

  function init(root) {
    if (!root || root.dataset.cbReady === 'true') return;
    root.dataset.cbReady = 'true';

    const modal = root.querySelector('[data-cb-modal]');
    const grid = root.querySelector('[data-cb-products]');
    if (!modal || !grid) return;

    const config = {
      defaultTier: root.dataset.defaultTier || '2',
      buy2Type: root.dataset.buy2Type || 'fixed',
      buy2Fixed: Number(root.dataset.buy2Fixed || 200),
      buy2Percent: Number(root.dataset.buy2Percent || 10),
      buy3Type: root.dataset.buy3Type || 'fixed',
      buy3Fixed: Number(root.dataset.buy3Fixed || 300),
      buy3Percent: Number(root.dataset.buy3Percent || 10),
      buy4Type: root.dataset.buy4Type || 'percent',
      buy4Fixed: Number(root.dataset.buy4Fixed || 500),
      buy4Percent: Number(root.dataset.buy4Percent || 10),
      prepaid: root.dataset.prepaid === 'true',
      prepaidValue: Number(root.dataset.prepaidValue || 5),
      prepaidAfter: root.dataset.prepaidAfter === 'true',
      max: Math.max(4, Number(root.dataset.max || 8)),
      autoUpgrade: root.dataset.autoUpgrade === 'true',
      sizeName: String(root.dataset.sizeName || 'Size').toLowerCase(),
      sizeMode: root.dataset.sizeMode || 'full',
      sizeDefault: root.dataset.sizeDefault || 'none',
      currency: root.dataset.currency || 'INR',
      titleMode: root.dataset.titleMode || 'characters',
      titleCharacters: Math.max(10, Number(root.dataset.titleCharacters || 70)),
      titleWords: Math.max(2, Number(root.dataset.titleWords || 10)),
      priceLayout: root.dataset.priceLayout || 'inline',
      priceAlign: root.dataset.priceAlign || 'right',
      stackLive: root.dataset.stackLive === 'true',
      stackSpeed: Math.max(1.5, Number(root.dataset.stackSpeed || 3)),
      stackRotation: Number(root.dataset.stackRotation || 8),
      stackShift: Number(root.dataset.stackShift || 90),
      stackFrontScale: Number(root.dataset.stackFrontScale || 106) / 100,
      stackPauseHover: root.dataset.stackPauseHover === 'true',
      stackMobile: root.dataset.stackMobile === 'true'
    };

    const labels = {
      empty: root.dataset.labelEmpty || 'Choose shirts to build your combo.',
      more: root.dataset.labelMore || 'Add more shirts to unlock combo savings.',
      unlocked: root.dataset.labelUnlocked || 'Combo saving unlocked.',
      max: root.dataset.labelMax || 'Maximum combo limit reached.',
      one: root.dataset.labelOne || 'shirt selected',
      many: root.dataset.labelMany || 'shirts selected',
      size: root.dataset.labelSize || 'Select size',
      sizeError: root.dataset.labelSizeError || 'Please select a size for every selected shirt.',
      atcLoading: root.dataset.labelAtcLoading || 'Adding…',
      atcSuccess: root.dataset.labelAtcSuccess || 'Combo added to cart.',
      atc: root.dataset.labelAtc || 'Add selected to cart',
      buyLoading: root.dataset.labelBuyLoading || 'Preparing checkout…',
      buy: root.dataset.labelBuy || 'Buy selected now'
    };

    const productMap = new Map();
    root.querySelectorAll('[data-cb-record]').forEach((record) => {
      try {
        const product = JSON.parse(record.value || record.textContent || '{}');
        if (!product?.handle) return;
        const collection = String(record.dataset.collection || '');
        if (!productMap.has(product.handle)) {
          product.__collections = new Set();
          productMap.set(product.handle, product);
        }
        const stored = productMap.get(product.handle);
        if (!stored.__collections) stored.__collections = new Set();
        if (collection) stored.__collections.add(collection);
      } catch (error) {
        console.warn('Combo builder product data error', error);
      }
    });

    const selected = new Map();
    const mainSelected = new Map();
    let currentTier = config.defaultTier;
    let currentFilter = 'all';
    let opener = null;
    let oldOverflow = '';
    let mainTier = config.defaultTier;
    let stackTimer = null;
    let stackActiveIndex = 0;

    const countEl = root.querySelector('[data-cb-count]');
    const checklistPanel = root.querySelector('[data-cb-checklist]');
    const checklistItems = root.querySelector('[data-cb-checklist-items]');
    const messageEl = root.querySelector('[data-cb-message]');
    const summaryBtn = root.querySelector('[data-cb-summary-open]');
    const mainCombo = root.querySelector('[data-cb-main-combo]');
    const mainImages = root.querySelector('[data-cb-main-images]');
    const mainTitle = root.querySelector('[data-cb-main-title]');
    const mainProducts = root.querySelector('[data-cb-main-products]');
    const mainComboPrice = root.querySelector('[data-cb-main-combo-price]');
    const mainSave = root.querySelector('[data-cb-main-save]');
    const mainPrepaid = root.querySelector('[data-cb-main-prepaid]');
    const mainMrp = root.querySelector('[data-cb-main-mrp]');
    const mainRegular = root.querySelector('[data-cb-main-regular]');
    const mainCustomize = root.querySelector('[data-cb-main-customize]');
    const mainAddBtn = root.querySelector('[data-cb-main-add]');
    const mainBuyBtn = root.querySelector('[data-cb-main-buy]');
    const mainMessage = root.querySelector('[data-cb-main-message]');

    function escapeHtml(value) {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function money(cents) {
      const value = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
          style: 'currency',
          currency: config.currency,
          maximumFractionDigits: Number.isInteger(value) ? 0 : 2
        }).format(value);
      } catch (_) {
        return `₹${Math.round(value)}`;
      }
    }

    function options(product) {
      if (!Array.isArray(product.options)) return [];
      return product.options.map((option, index) => ({
        name: typeof option === 'string' ? option : (option?.name || ''),
        position: typeof option === 'object' && option?.position ? option.position : index + 1
      }));
    }

    function sizeIndex(product) {
      return options(product).findIndex((option) => String(option.name || '').toLowerCase() === config.sizeName);
    }

    function variantOptions(variant) {
      if (Array.isArray(variant?.options)) return variant.options;
      return [variant?.option1, variant?.option2, variant?.option3].filter((v) => v != null);
    }

    function firstAvailable(product) {
      return (product.variants || []).find((v) => v.available) || (product.variants || [])[0] || null;
    }

    function sizesFor(product) {
      const index = sizeIndex(product);
      if (index < 0) return [];
      const seen = new Set();
      const result = [];
      (product.variants || []).forEach((variant) => {
        const value = variantOptions(variant)[index];
        if (value != null && !seen.has(String(value))) {
          seen.add(String(value));
          result.push(String(value));
        }
      });
      return result;
    }

    function variantForSize(product, size) {
      const index = sizeIndex(product);
      if (index < 0) return firstAvailable(product);
      const matches = (product.variants || []).filter((variant) => String(variantOptions(variant)[index]) === String(size));
      return matches.find((variant) => variant.available) || matches[0] || null;
    }

    function sizeDisplay(value) {
      const text = String(value || '');
      if (config.sizeMode === 'letter_only' && text.includes('/')) return text.split('/')[0].trim();
      if (config.sizeMode === 'number_only' && text.includes('/')) return text.split('/').slice(-1)[0].trim();
      return text;
    }

    function imageOf(product) {
      if (typeof product.featured_image === 'string' && product.featured_image) return product.featured_image;
      if (product.featured_image?.src) return product.featured_image.src;
      const first = Array.isArray(product.images) ? product.images[0] : null;
      return typeof first === 'string' ? first : (first?.src || first?.url || '');
    }

    function baseVariant(product) {
      return firstAvailable(product);
    }

    function createCard(product) {
      const card = document.createElement('article');
      card.className = 'cb-product';
      card.dataset.handle = product.handle;
      const base = baseVariant(product);
      const image = imageOf(product);
      const price = Number(base?.price ?? product.price ?? 0);
      const compare = Number(base?.compare_at_price ?? product.compare_at_price ?? 0);

      card.innerHTML = `
        <div class="cb-product-image">
          ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title || '')}" loading="lazy">` : '<div style="width:100%;height:100%;display:grid;place-items:center;color:#999">No image</div>'}
          <button type="button" class="cb-check" data-cb-select aria-pressed="false" aria-label="Select ${escapeHtml(product.title || 'product')}"><span data-cb-select-label>Select</span></button>
        </div>
        <div class="cb-product-content">
          <h4 class="cb-product-title">${escapeHtml(displayTitle(product.title || ''))}</h4>
          <div class="cb-product-price">
            ${compare > price ? `<span class="cb-product-compare" data-cb-compare>${money(compare)}</span>` : ''}
            <span data-cb-price>${money(price)}</span>
          </div>
          <div class="cb-sizes" data-cb-sizes hidden>
            <p class="cb-size-label">${escapeHtml(labels.size)}</p>
            <div class="cb-size-list" data-cb-size-list></div>
            <p class="cb-size-warning" data-cb-size-warning>Please select a size</p>
          </div>
        </div>
      `;

      const sizeList = card.querySelector('[data-cb-size-list]');
      sizesFor(product).forEach((value) => {
        const variant = variantForSize(product, value);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cb-size';
        button.dataset.cbSize = value;
        button.textContent = sizeDisplay(value);
        if (!variant?.available) button.disabled = true;
        sizeList?.appendChild(button);
      });
      return card;
    }

    function renderProducts() {
      grid.innerHTML = '';
      [...productMap.values()].forEach((product) => grid.appendChild(createCard(product)));
      applyFilter(currentFilter);
    }

    function applyFilter(filter) {
      currentFilter = filter || 'all';
      grid.querySelectorAll('.cb-product').forEach((card) => {
        const product = productMap.get(card.dataset.handle);
        card.hidden = !(currentFilter === 'all' || product?.__collections?.has(String(currentFilter)));
      });
      root.querySelectorAll('[data-cb-collection]').forEach((button) => {
        button.classList.toggle('is-active', button.dataset.cbCollection === currentFilter);
      });
    }

    function limitForTier(tier) {
      if (config.autoUpgrade) return config.max;
      if (tier === '2') return 2;
      if (tier === '3') return 3;
      return config.max;
    }

    function minimumForTier(tier) {
      if (tier === '2') return 2;
      if (tier === '3') return 3;
      return 4;
    }

    function presetForTier(tier) {
      return root.querySelector(`[data-cb-preset][data-tier="${tier}"]`);
    }

    function defaultsForTier(tier) {
      const preset = presetForTier(tier);
      return String(preset?.dataset.handles || '').split(',').map((v) => v.trim()).filter(Boolean);
    }

    function displayTitle(value) {
      const text = String(value || '').trim();
      if (!text) return '';
      if (config.titleMode === 'full') return text;
      if (config.titleMode === 'words') {
        const words = text.split(/\s+/);
        return words.length > config.titleWords ? `${words.slice(0, config.titleWords).join(' ')}…` : text;
      }
      return text.length > config.titleCharacters ? `${text.slice(0, config.titleCharacters).trim()}…` : text;
    }

    function createEntry(product) {
      if (!product) return null;
      const hasSizes = sizeIndex(product) >= 0;
      let size = null;
      let variant = null;
      if (hasSizes && config.sizeDefault === 'first_available') {
        size = sizesFor(product).find((value) => variantForSize(product, value)?.available) || null;
        variant = size ? variantForSize(product, size) : null;
      } else if (!hasSizes) {
        variant = firstAvailable(product);
      }
      return { product, size, variantId: variant?.id || null };
    }

    function cloneEntry(entry) {
      return entry ? { product: entry.product, size: entry.size || null, variantId: entry.variantId || null } : null;
    }

    function loadMainPreset(tier) {
      mainTier = tier || config.defaultTier;
      mainSelected.clear();
      defaultsForTier(mainTier).forEach((handle) => {
        const entry = createEntry(productMap.get(handle));
        if (entry) mainSelected.set(handle, entry);
      });
    }

    function mainVariant(entry) {
      if (!entry) return null;
      if (entry.variantId) return (entry.product.variants || []).find((variant) => String(variant.id) === String(entry.variantId)) || null;
      if (sizeIndex(entry.product) < 0) return firstAvailable(entry.product);
      return null;
    }

    function totalsForEntries(map) {
      let mrp = 0;
      let selling = 0;
      map.forEach((entry) => {
        const variant = mainVariant(entry) || firstAvailable(entry.product);
        if (!variant) return;
        const price = Number(variant.price || 0);
        const compare = Number(variant.compare_at_price || 0);
        selling += price;
        mrp += compare > price ? compare : price;
      });
      const discount = discountAmount(selling, map.size);
      const combo = Math.max(0, selling - discount);
      const prepaidBase = config.prepaidAfter ? combo : selling;
      const preSave = config.prepaid ? Math.round(prepaidBase * config.prepaidValue / 100) : 0;
      return { mrp, selling, discount, combo, totalSave: Math.max(0, mrp - combo), preSave, preTotal: Math.max(0, combo - preSave) };
    }

    function mainSizesComplete() {
      if (!mainSelected.size) return false;
      for (const entry of mainSelected.values()) {
        if (sizeIndex(entry.product) >= 0 && !entry.variantId) return false;
        if (!mainVariant(entry)?.available) return false;
      }
      return true;
    }

    function setMainMessage(text) {
      if (mainMessage) mainMessage.textContent = text || '';
    }

    function layoutMainStack(activeIndex = 0) {
      if (!mainImages) return;
      const cards = [...mainImages.querySelectorAll('.cb-main-image')];
      const count = cards.length;
      if (!count) return;
      cards.forEach((card, index) => {
        let delta = (index - activeIndex + count) % count;
        if (delta > count / 2) delta -= count;
        let x = 0, r = 0, s = .94, z = 2, opacity = .94;
        if (delta === 0) {
          x = count === 2 ? config.stackShift * .16 : 0;
          s = config.stackFrontScale;
          z = 20;
          opacity = 1;
          card.classList.add('is-front');
        } else {
          card.classList.remove('is-front');
          const abs = Math.abs(delta);
          const side = delta < 0 ? -1 : 1;
          if (count === 2) {
            x = -config.stackShift * .72;
            r = -config.stackRotation;
            s = .96;
            z = 8;
          } else {
            x = side * config.stackShift * Math.min(1.65, .9 + ((abs - 1) * .55));
            r = side * config.stackRotation * Math.min(1.55, 1 + ((abs - 1) * .35));
            s = Math.max(.86, .96 - ((abs - 1) * .05));
            z = Math.max(3, 12 - abs);
            opacity = Math.max(.82, .96 - ((abs - 1) * .05));
          }
        }
        card.style.setProperty('--cb-stack-x', `${x}px`);
        card.style.setProperty('--cb-stack-r', `${r}deg`);
        card.style.setProperty('--cb-stack-s', s);
        card.style.setProperty('--cb-stack-z', z);
        card.style.setProperty('--cb-stack-opacity', opacity);
      });
    }

    function stopStackAnimation() {
      if (stackTimer) window.clearInterval(stackTimer);
      stackTimer = null;
    }

    function startStackAnimation() {
      stopStackAnimation();
      const cards = mainImages ? [...mainImages.querySelectorAll('.cb-main-image')] : [];
      if (cards.length < 2) return;
      stackActiveIndex = 0;
      layoutMainStack(stackActiveIndex);
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      if (!config.stackLive || (mobile && !config.stackMobile)) return;
      stackTimer = window.setInterval(() => {
        if (config.stackPauseHover && mainImages?.matches(':hover')) return;
        stackActiveIndex = (stackActiveIndex + 1) % cards.length;
        layoutMainStack(stackActiveIndex);
      }, config.stackSpeed * 1000);
    }

    function renderMainCombo() {
      const preset = presetForTier(mainTier);
      const entries = [...mainSelected.values()];
      const products = entries.map((entry) => entry.product);
      root.querySelectorAll('[data-cb-tier-filter]').forEach((tab) => tab.classList.toggle('is-active', tab.dataset.cbTierFilter === mainTier));
      if (!mainCombo) return;

      if (mainTitle) {
        mainTitle.textContent = preset?.dataset.title || `${products.length || (mainTier === '4plus' ? '4+' : mainTier)} Shirt Combo`;
        mainTitle.hidden = !mainTitle.textContent.trim();
      }

      if (mainImages) {
        mainImages.innerHTML = '';
        const visible = Math.min(5, products.length);
        products.slice(0, visible).forEach((product, index) => {
          const wrap = document.createElement('div');
          wrap.className = 'cb-main-image';
          const image = imageOf(product);
          wrap.innerHTML = image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title || '')}" loading="lazy">` : '<div style="width:100%;height:100%;display:grid;place-items:center;color:#999">No image</div>';
          if (index === visible - 1 && products.length > visible) wrap.insertAdjacentHTML('beforeend', `<span class="cb-main-image__more">+${products.length - visible}</span>`);
          mainImages.appendChild(wrap);
        });
        startStackAnimation();
      }

      if (mainProducts) {
        mainProducts.innerHTML = '';
        entries.forEach((entry) => {
          const product = entry.product;
          const variant = mainVariant(entry) || firstAvailable(product);
          if (!variant) return;
          const price = Number(variant.price || 0);
          const compare = Number(variant.compare_at_price || 0);
          const row = document.createElement('div');
          row.className = 'cb-main-product';
          const priceClasses = `cb-main-product__prices${config.priceLayout === 'stacked' ? ' is-stacked' : ''}${config.priceAlign === 'left' ? ' is-left' : ''}`;
          const sizeValues = sizesFor(product);
          const sizesHtml = sizeValues.length ? `<div class="cb-main-sizes"><span class="cb-main-size-label">${escapeHtml(labels.size)}</span>${sizeValues.map((value) => {
            const v = variantForSize(product, value);
            return `<button type="button" class="cb-main-size${entry.size === value ? ' is-selected' : ''}" data-cb-main-size data-handle="${escapeHtml(product.handle)}" data-size="${escapeHtml(value)}"${!v?.available ? ' disabled' : ''}>${escapeHtml(sizeDisplay(value))}</button>`;
          }).join('')}</div>` : '';
          const warning = sizeValues.length && !entry.variantId ? `<p class="cb-main-size-warning">${escapeHtml(labels.sizeError)}</p>` : '';
          row.innerHTML = `<p class="cb-main-product__title">${escapeHtml(displayTitle(product.title || ''))}</p><div class="${priceClasses}">${compare > price ? `<span class="cb-main-product__mrp">MRP ${money(compare)}</span>` : ''}<span class="cb-main-product__price">${money(price)}</span></div>${sizesHtml}${warning}`;
          mainProducts.appendChild(row);
        });
      }

      const t = totalsForEntries(mainSelected);
      if (mainMrp) mainMrp.textContent = money(t.mrp);
      if (mainRegular) mainRegular.textContent = money(t.selling);
      if (mainComboPrice) mainComboPrice.textContent = money(t.combo);
      if (mainSave) mainSave.textContent = money(t.totalSave);
      if (mainPrepaid) mainPrepaid.textContent = config.prepaid ? `Prepaid total ${money(t.preTotal)}` : '';
      const ready = mainSelected.size >= minimumForTier(mainTier) && mainSizesComplete();
      if (mainAddBtn) mainAddBtn.disabled = !ready;
      if (mainBuyBtn) mainBuyBtn.disabled = !ready;
      if (mainCustomize) {
        mainCustomize.dataset.tier = mainTier;
        mainCustomize.dataset.handles = [...mainSelected.keys()].join(',');
        const cta = preset?.dataset.cta || mainCustomize.dataset.defaultText || 'Customize combo';
        const textNode = [...mainCustomize.childNodes].find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        if (textNode) textNode.textContent = ` ${cta} `;
      }
    }

    function setMainSize(handle, size) {
      const entry = mainSelected.get(handle);
      if (!entry) return;
      const variant = variantForSize(entry.product, size);
      if (!variant?.available) return;
      entry.size = size;
      entry.variantId = variant.id;
      mainSelected.set(handle, entry);
      setMainMessage('');
      renderMainCombo();
    }

    async function addMainItems(goCheckout) {
      if (mainSelected.size < minimumForTier(mainTier)) return setMainMessage(labels.more);
      if (!mainSizesComplete()) return setMainMessage(labels.sizeError);
      const items = [];
      mainSelected.forEach((entry) => {
        const variant = mainVariant(entry);
        if (variant?.available) items.push({ id: Number(variant.id), quantity: 1 });
      });
      if (items.length !== mainSelected.size) return setMainMessage(labels.sizeError);
      const button = goCheckout ? mainBuyBtn : mainAddBtn;
      const label = button?.querySelector(goCheckout ? '[data-cb-main-buy-label]' : '[data-cb-main-add-label]');
      const original = goCheckout ? labels.buy : labels.atc;
      if (button) button.disabled = true;
      if (label) label.textContent = goCheckout ? labels.buyLoading : labels.atcLoading;
      setMainMessage('');
      try {
        const shopRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${shopRoot}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload?.description || payload?.message || 'Unable to add combo.');
        if (goCheckout) return void (window.location.href = `${shopRoot}checkout`);
        try {
          const cartResponse = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
          const cart = await cartResponse.json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
        } catch (_) {}
        setMainMessage(labels.atcSuccess);
      } catch (error) {
        setMainMessage(error?.message || 'Unable to add combo.');
      } finally {
        if (label) label.textContent = original;
        renderMainCombo();
      }
    }

    function addSelection(product) {
      if (!product || selected.has(product.handle)) return true;
      if (selected.size >= limitForTier(currentTier)) {
        setMessage(labels.max);
        return false;
      }

      const hasSizes = sizeIndex(product) >= 0;
      let chosenSize = null;
      let variant = null;

      if (hasSizes && config.sizeDefault === 'first_available') {
        chosenSize = sizesFor(product).find((value) => variantForSize(product, value)?.available) || null;
        variant = chosenSize ? variantForSize(product, chosenSize) : null;
      } else if (!hasSizes) {
        variant = firstAvailable(product);
      }

      selected.set(product.handle, {
        product,
        size: chosenSize,
        variantId: variant?.id || null
      });
      return true;
    }

    function setSize(handle, size) {
      const entry = selected.get(handle);
      if (!entry) return;
      const variant = variantForSize(entry.product, size);
      if (!variant?.available) return;
      entry.size = size;
      entry.variantId = variant.id;
      selected.set(handle, entry);
    }

    function selectedVariant(entry) {
      if (!entry) return null;
      if (entry.variantId) return (entry.product.variants || []).find((variant) => String(variant.id) === String(entry.variantId)) || null;
      return firstAvailable(entry.product);
    }

    function syncCards() {
      grid.querySelectorAll('.cb-product').forEach((card) => {
        const entry = selected.get(card.dataset.handle);
        const isSelected = Boolean(entry);
        card.classList.toggle('is-selected', isSelected);
        const selectBtn = card.querySelector('[data-cb-select]');
        selectBtn?.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        const selectLabel = card.querySelector('[data-cb-select-label]');
        if (selectLabel) selectLabel.textContent = isSelected ? 'Selected' : 'Select';

        const product = productMap.get(card.dataset.handle);
        const sizeWrap = card.querySelector('[data-cb-sizes]');
        if (sizeWrap) sizeWrap.hidden = !(isSelected && sizesFor(product).length);
        const warningEl = card.querySelector('[data-cb-size-warning]');
        if (warningEl) warningEl.classList.toggle('is-visible', isSelected && sizesFor(product).length && !entry?.variantId);

        card.querySelectorAll('[data-cb-size]').forEach((button) => {
          button.classList.toggle('is-selected', isSelected && entry?.size === button.dataset.cbSize);
        });

        const variant = isSelected ? selectedVariant(entry) : firstAvailable(product);
        if (variant) {
          const priceEl = card.querySelector('[data-cb-price]');
          const compareEl = card.querySelector('[data-cb-compare]');
          if (priceEl) priceEl.textContent = money(variant.price);
          if (compareEl) {
            const compare = Number(variant.compare_at_price || 0);
            compareEl.textContent = compare > Number(variant.price || 0) ? money(compare) : '';
          }
        }
      });
    }

    function discountAmount(subtotal, count) {
      if (count < 2) return 0;
      let type = 'fixed';
      let value = 0;
      if (count === 2) {
        type = config.buy2Type;
        value = type === 'percent' ? config.buy2Percent : config.buy2Fixed;
      } else if (count === 3) {
        type = config.buy3Type;
        value = type === 'percent' ? config.buy3Percent : config.buy3Fixed;
      } else {
        type = config.buy4Type;
        value = type === 'percent' ? config.buy4Percent : config.buy4Fixed;
      }
      const amount = type === 'percent' ? Math.round(subtotal * value / 100) : Math.round(value * 100);
      return Math.min(subtotal, Math.max(0, amount));
    }

    function totals() {
      let mrp = 0;
      let selling = 0;
      selected.forEach((entry) => {
        const variant = selectedVariant(entry);
        if (!variant) return;
        const price = Number(variant.price || 0);
        const compare = Number(variant.compare_at_price || 0);
        selling += price;
        mrp += compare > price ? compare : price;
      });
      const discount = discountAmount(selling, selected.size);
      const combo = Math.max(0, selling - discount);
      const prepaidBase = config.prepaidAfter ? combo : selling;
      const preSave = config.prepaid ? Math.round(prepaidBase * config.prepaidValue / 100) : 0;
      const preTotal = Math.max(0, combo - preSave);
      return { mrp, selling, discount, combo, preSave, preTotal, totalSave: Math.max(0, mrp - combo) };
    }

    function sizesComplete() {
      if (!selected.size) return false;
      for (const entry of selected.values()) {
        if (sizeIndex(entry.product) >= 0 && !entry.variantId) return false;
        if (!selectedVariant(entry)?.available) return false;
      }
      return true;
    }

    function updateTierFromCount() {
      if (!config.autoUpgrade) return;
      if (selected.size >= 4) currentTier = '4plus';
      else if (selected.size === 3) currentTier = '3';
      else if (selected.size === 2) currentTier = '2';
    }

    function helperText() {
      const count = selected.size;
      if (!count) return labels.empty;
      if (count === 1) return labels.more;
      if (count === 2 && config.autoUpgrade && config.max >= 3) return 'Add 1 more shirt to unlock the 3-shirt offer.';
      if (count === 3 && config.autoUpgrade && config.max >= 4) return 'Add 1 more shirt to unlock the 4+ offer.';
      return labels.unlocked;
    }

    function setText(selector, text) {
      const el = root.querySelector(selector);
      if (el) el.textContent = text;
    }


    function setMessage(text) {
      if (messageEl) messageEl.textContent = text || '';
    }

    function renderChecklist() {
      if (!checklistItems) return;
      checklistItems.innerHTML = '';
      const entries = [...selected.entries()].sort((a, b) => {
        const aMissing = sizeIndex(a[1].product) >= 0 && !a[1].variantId ? 0 : 1;
        const bMissing = sizeIndex(b[1].product) >= 0 && !b[1].variantId ? 0 : 1;
        return aMissing - bMissing;
      });
      if (!entries.length) {
        checklistItems.innerHTML = '<p>No shirts selected yet.</p>';
        return;
      }
      entries.forEach(([handle, entry]) => {
        const image = imageOf(entry.product);
        const hasSizes = sizeIndex(entry.product) >= 0;
        const incomplete = hasSizes && !entry.variantId;
        const item = document.createElement('div');
        item.className = `cb-check-item${incomplete ? ' is-incomplete' : ''}`;
        const sizeButtons = hasSizes ? sizesFor(entry.product).map((size) => {
          const variant = variantForSize(entry.product, size);
          const active = String(entry.size || '') === String(size);
          return `<button type="button" class="cb-check-size${active ? ' is-selected' : ''}" data-cb-check-size data-handle="${escapeHtml(handle)}" data-size="${escapeHtml(size)}" ${variant?.available ? '' : 'disabled'}>${escapeHtml(sizeDisplay(size))}</button>`;
        }).join('') : '';
        item.innerHTML = `
          ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(entry.product.title || '')}" loading="lazy">` : '<div></div>'}
          <div>
            <h4>${escapeHtml(displayTitle(entry.product.title || ''))}</h4>
            <p class="cb-check-item__status${incomplete ? ' is-missing' : ''}">${hasSizes ? (incomplete ? 'Size required — select below' : `Selected size: ${escapeHtml(sizeDisplay(entry.size))}`) : 'Ready'}</p>
            ${sizeButtons ? `<div class="cb-check-sizes">${sizeButtons}</div>` : ''}
          </div>`;
        checklistItems.appendChild(item);
      });
    }

    function openChecklist() {
      renderChecklist();
      if (checklistPanel) checklistPanel.hidden = false;
    }

    function closeChecklist() {
      if (checklistPanel) checklistPanel.hidden = true;
    }

    function updateUI() {
      updateTierFromCount();
      syncCards();
      const count = selected.size;
      if (countEl) countEl.textContent = `${count} ${count === 1 ? labels.one : labels.many}`;
      if (summaryBtn) summaryBtn.disabled = count === 0;
      const checklistBtn = root.querySelector('[data-cb-checklist-open]');
      if (checklistBtn) checklistBtn.disabled = count === 0;

      const ready = count >= minimumForTier(currentTier) && sizesComplete();
      if (checklistPanel && !checklistPanel.hidden) renderChecklist();
    }

    function loadDefaults(tier, explicitHandles) {
      selected.clear();
      const handles = explicitHandles?.length ? explicitHandles : defaultsForTier(tier);
      handles.forEach((handle) => {
        const product = productMap.get(handle);
        if (product) addSelection(product);
      });
    }

    function openBuilder(button) {
      opener = button || document.activeElement;
      currentTier = button?.dataset?.tier || mainTier || config.defaultTier;
      selected.clear();
      if (button?.hasAttribute('data-cb-main-customize') && currentTier === mainTier && mainSelected.size) {
        mainSelected.forEach((entry, handle) => selected.set(handle, cloneEntry(entry)));
      } else {
        const explicit = String(button?.dataset?.handles || '').split(',').map((v) => v.trim()).filter(Boolean);
        const handles = explicit.length ? explicit : defaultsForTier(currentTier);
        handles.forEach((handle) => { const product = productMap.get(handle); if (product) addSelection(product); });
      }
      closeChecklist();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      setMessage('');
      updateUI();
      requestAnimationFrame(() => root.querySelector('.cb-close')?.focus());
    }

    function closeBuilder() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = oldOverflow;
      closeChecklist();
      setMessage('');
      if (opener && typeof opener.focus === 'function') opener.focus();
    }

    function switchTier(tier) {
      currentTier = tier;
      loadDefaults(tier, []);
      closeChecklist();
      setMessage('');
      updateUI();
    }


    renderProducts();
    loadMainPreset(mainTier);
    renderMainCombo();
    updateUI();

    root.addEventListener('click', (event) => {
      const tierFilter = event.target.closest('[data-cb-tier-filter]');
      if (tierFilter) {
        const tier = tierFilter.dataset.cbTierFilter;
        loadMainPreset(tier);
        setMainMessage('');
        renderMainCombo();
        return;
      }

      const open = event.target.closest('[data-cb-open]');
      if (open) {
        event.preventDefault();
        openBuilder(open);
        return;
      }

      if (event.target.closest('[data-cb-close]')) {
        event.preventDefault();
        closeBuilder();
        return;
      }

      const filter = event.target.closest('[data-cb-collection]');
      if (filter) {
        applyFilter(filter.dataset.cbCollection || 'all');
        return;
      }

      if (event.target.closest('[data-cb-checklist-open]')) {
        openChecklist();
        return;
      }
      if (event.target.closest('[data-cb-checklist-close]')) {
        closeChecklist();
        return;
      }

      const modalTier = event.target.closest('[data-cb-modal-tier]');
      if (modalTier) {
        switchTier(modalTier.dataset.cbModalTier);
        return;
      }

      const selectButton = event.target.closest('[data-cb-select]');
      if (selectButton) {
        const card = selectButton.closest('.cb-product');
        const handle = card?.dataset.handle;
        const product = productMap.get(handle);
        if (!product) return;
        if (selected.has(handle)) selected.delete(handle);
        else addSelection(product);
        setMessage('');
        updateUI();
        return;
      }

      const checklistSize = event.target.closest('[data-cb-check-size]');
      if (checklistSize && !checklistSize.disabled) {
        setSize(checklistSize.dataset.handle, checklistSize.dataset.size);
        setMessage('');
        updateUI();
        renderChecklist();
        return;
      }

      const sizeButton = event.target.closest('[data-cb-size]');
      if (sizeButton && !sizeButton.disabled) {
        const card = sizeButton.closest('.cb-product');
        setSize(card?.dataset.handle, sizeButton.dataset.cbSize);
        setMessage('');
        updateUI();
        return;
      }


      if (event.target.closest('[data-cb-summary-open]')) {
        if (selected.size < minimumForTier(currentTier)) { setMessage(labels.more); return; }
        if (!sizesComplete()) { setMessage(labels.sizeError); openChecklist(); return; }
        mainTier = currentTier;
        mainSelected.clear();
        selected.forEach((entry, handle) => mainSelected.set(handle, cloneEntry(entry)));
        closeChecklist();
        closeBuilder();
        setMainMessage('');
        renderMainCombo();
        window.setTimeout(() => mainCombo?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 60);
        return;
      }

      const mainSize = event.target.closest('[data-cb-main-size]');
      if (mainSize && !mainSize.disabled) { setMainSize(mainSize.dataset.handle, mainSize.dataset.size); return; }
      if (event.target.closest('[data-cb-main-add]')) { addMainItems(false); return; }
      if (event.target.closest('[data-cb-main-buy]')) { addMainItems(true); return; }
    });

    document.addEventListener('keydown', (event) => {
      if (!modal.hidden && event.key === 'Escape') closeBuilder();
    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target || document));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.lastScrollTop = 0;
      this.ticking = false;
    }

    connectedCallback() {
      this.headerSection = document.querySelector('.section-header');
      this.stickyType = this.getAttribute('data-sticky-type') || 'none';
      this.animationStyle = this.getAttribute('data-animation-style') || 'slide';
      this.scrollTrigger = Number(this.getAttribute('data-scroll-trigger') || 80);
      this.header = this.querySelector('.cds-header');
      this.predictiveSearch = this.querySelector('predictive-search');

      if (!this.headerSection) return;

      this.headerSection.classList.add(`gksen-animation-${this.animationStyle}`);
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.stickyType === 'always' || this.stickyType === 'reduce-logo-size') {
        this.showHeader();
      }

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    setHeaderHeight() {
      if (this.headerSection) {
        document.documentElement.style.setProperty('--header-height', `${this.headerSection.offsetHeight}px`);
      }
    }

    onScroll() {
      if (this.ticking) return;

      this.ticking = true;

      window.requestAnimationFrame(() => {
        this.updateHeader();
        this.ticking = false;
      });
    }

    updateHeader() {
      if (!this.headerSection || this.stickyType === 'none') return;

      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isScrollingDown = currentScrollTop > this.lastScrollTop;
      const isPastTrigger = currentScrollTop > this.scrollTrigger;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (isPastTrigger) {
        this.headerSection.classList.add('gksen-header-scrolled');
      } else {
        this.headerSection.classList.remove('gksen-header-scrolled');
      }

      if (this.stickyType === 'always' || this.stickyType === 'reduce-logo-size') {
        this.showHeader();
        this.lastScrollTop = Math.max(currentScrollTop, 0);
        return;
      }

      if (this.stickyType === 'hide-on-scroll') {
        if (isPastTrigger) {
          this.hideHeader();
        } else {
          this.showHeader();
        }

        this.lastScrollTop = Math.max(currentScrollTop, 0);
        return;
      }

      if (this.stickyType === 'on-scroll-up') {
        if (isScrollingDown && isPastTrigger) {
          this.hideHeader();
        } else {
          this.showHeader();
        }

        if (currentScrollTop <= 5) {
          this.resetHeader();
        }
      }

      this.lastScrollTop = Math.max(currentScrollTop, 0);
    }

    hideHeader() {
      this.headerSection.classList.add('gksen-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    showHeader() {
      this.headerSection.classList.remove('gksen-header-hidden');
    }

    resetHeader() {
      this.headerSection.classList.remove('gksen-header-hidden', 'gksen-header-scrolled');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
        }
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.querySelector('details-modal');

      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
